import { HappySquirrel } from 'Icons'

import PoweredBySked from './Common/PoweredBySked'

const EmptyUpcomingPosts: React.FC = () => {
  return (
    <div className="mx-auto mb-[120px] mt-[70px] grid place-items-center max-[767px]:my-[14px] [&>svg]:mb-28 [&>svg]:mt-10 [&>svg]:w-[214px] max-[767px]:[&>svg]:mb-[65px] max-[767px]:[&>svg]:mt-[60px]">
      <div className="max-w-[360px] rounded-[10px] bg-[#f0f8e7] px-[30px] py-5 text-center">
        <h2 className="text-[32px] font-medium">Time to zen out!</h2>
        <span className="text-sm">
          No upcoming posts or posts awaiting approval.
        </span>
      </div>
      <HappySquirrel data-testid="squirrel_logo" />
      <PoweredBySked />
    </div>
  )
}

export default EmptyUpcomingPosts
